export enum WidgetCheckboxV0Mode {
  SELECT_CATEGORY = 'SELECT_CATEGORY',
  TREE = 'TREE',
  CHECKBOX = 'CHECKBOX',
  CHILDREN = 'CHILDREN'
}
